import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'primereact/button';
import React from 'react';
import { ModelOfDemand } from 'src/database';
import { dateToString } from 'src/utils/dateToString';

import '../styles.scss';

interface ServiceCardProps {
    demand: ModelOfDemand;
    // eslint-disable-next-line no-empty-pattern
    handleClick: ({}: any) => void;
}

const DemandServiceCard: React.FC<ServiceCardProps> = ({ demand, handleClick }) => {
    return (
        <div className='container-row'>
            <div className='container'>
                <div className='card-header'>
                    <span>Prioridade - {demand.DESCRICAO_PRIORIDADE}</span>
                </div>
                <div className='card-body'>
                    <div className='card-column'>
                        <div className='card-content'>
                            <span className='info-title'>Veículo</span>
                            <span className='info-text'>{demand.DESCRICAO_VEICULO}</span>
                        </div>
                        <div className='card-content'>
                            <span className='info-title'>Descrição da demanda</span>
                            <span className='info-text'>{demand.DESCRICAO}</span>
                        </div>
                        <div className='card-content'>
                            <span className='info-title'>Requisitado por</span>
                            <span className='info-text'>{demand.NOME_PESSOAORIGEM}</span>
                        </div>
                        <div className='card-content'>
                            <span className='info-title'>Unidade Responsável</span>
                            <span className='info-text'>{demand.NOME_ORGAOUNIDADEDESTINO}</span>
                        </div>
                    </div>

                    <div className='card-column'>
                        <div className='card-content'>
                            <span className='info-title'>Placa</span>
                            <span className='info-text'>{demand.PLACA_VEICULO}</span>
                        </div>
                        <div className='card-content'>
                            <span className='info-title'>Data</span>
                            <span className='info-text'>{dateToString(demand.DATA, 'br')}</span>
                        </div>
                        <div className='card-content'>
                            <span className='info-title'>Órgão</span>
                            <span className='info-text'>{demand.NOME_ORGAO}</span>
                        </div>
                        <div className='button-container'>
                            <Button className='button' onClick={handleClick}>
                                <FontAwesomeIcon icon={faPlus} />
                                <span className='p-ml-2'> Criar ordem de serviço</span>
                            </Button>
                        </div>
                        <div className='button-container'>
                            <Button className='button' onClick={handleClick}>
                                <FontAwesomeIcon icon={faPlus} />
                                <span className='p-ml-2'>Editar demanda</span>
                            </Button>
                        </div>
                        <div className='button-container'>
                            <Button className='button' onClick={handleClick}>
                                <FontAwesomeIcon icon={faPlus} />
                                <span className='p-ml-2'>Imprimir ordem de abastecimento</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DemandServiceCard;
